import { t } from "@/i18n";
import { clampPercent } from "@/lib/utils";

interface HealthRingProps {
  /** 0-100 arasi saglik skoru; null → '—' (bilinmiyor). */
  value: number | null;
  size?: number;
}

/** Saglik halkasi — eski arayuzdeki SVG halka; null skor '—' gosterir. */
export function HealthRing({ value, size = 96 }: HealthRingProps) {
  const pct = value == null ? null : clampPercent(value);
  const radius = size / 2 - 8;
  const circumference = 2 * Math.PI * radius;
  const dash = pct == null ? 0 : (pct / 100) * circumference;
  const color = pct == null ? "#94A3B8" : pct >= 80 ? "#059669" : pct >= 50 ? "#D97706" : "#DC2626";
  const label = pct == null ? t("health.unknown") : `${pct}%`;

  return (
    <div className="inline-flex flex-col items-center gap-1" role="img" aria-label={`${t("health.label")}: ${label}`}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="#E0E7FF" strokeWidth={8} fill="none" />
        {pct != null && (
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={color}
            strokeWidth={8}
            fill="none"
            strokeDasharray={`${dash} ${circumference - dash}`}
            strokeLinecap="round"
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
          />
        )}
        <text
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          fontSize={size * 0.22}
          fontWeight={700}
          fill="#1A2855"
        >
          {pct == null ? t("health.unknown") : pct}
        </text>
      </svg>
      <span className="text-xs text-muted">{t("health.label")}</span>
    </div>
  );
}
